<template>
  <div class="select-area-pc">
    <Row :gutter="5">
      <Col v-for="(area, index) in areaList" :key="index" :span="setColSpan()" :md="setColMd()">
        <Select
          v-model:value="area.code"
          class="select-item"
          :show-search="showSearch"
          :allow-clear="allowClear"
          :class="{ first: index === 0 }"
          :dropdown-match-select-width="200"
          :placeholder="
            placeholderTip && placeholderTip.length ? `请选择${placeholderTip[index]}` : '请选择'
          "
          option-label-prop="label"
          :filter-option="filterOption"
          :bordered="border"
          @change="selectAreaItem(area, index)"
        >
          <SelectOption v-for="item in area.list" :key="item.areaCode" :label="item.areaName">
            {{ item.areaName }}
          </SelectOption>
        </Select>
      </Col>
    </Row>
  </div>
</template>

<script lang="ts">
export default {
  name: 'YSelectAreaPc'
}
</script>
<script setup lang="ts">
import { ref, watch } from 'vue'
import { Select, Row, Col } from 'ant-design-vue'
import {
  AreaTreeItem,
  OptionType,
  AreaItem,
  selectAreaProps,
  getProvince,
  getCity,
  getDistrict,
  getStreet
} from './selectArea'
import { onMounted } from 'vue'
import 'ant-design-vue/es/select/style/css'

const SelectOption = Select.Option
const props = defineProps(selectAreaProps)
const emits = defineEmits(['submit'])
const filterOption = (input: string, option: OptionType): boolean => {
  return option.label.indexOf(input) >= 0
}
const defaultList = [
  {
    label: '省',
    value: 0,
    nextValue: 1,
    code: undefined as number | undefined,
    list: [] as AreaTreeItem[]
  },
  {
    label: '市',
    value: 1,
    nextValue: 2,
    code: undefined as number | undefined,
    list: [] as AreaTreeItem[]
  },
  {
    label: '区',
    value: 2,
    nextValue: 3,
    code: undefined as number | undefined,
    list: [] as AreaTreeItem[]
  },
  {
    label: '街道',
    value: 3,
    nextValue: -1,
    code: undefined as number | undefined,
    list: [] as AreaTreeItem[]
  }
] as AreaItem[]

let areaList = ref([...defaultList])
let flag = true

const selectAreaItem = (area: AreaItem, index: number) => {
  let selectedOptions = [] as any[]
  areaList.value.forEach((item: AreaItem) => {
    if (item.value < area.nextValue || area.nextValue === -1) {
      const { code, list } = item
      const name = list.find((val) => val.areaCode === code)?.areaName || ''
      if (code) {
        const valItem = {
          areaCode: code,
          areaName: name
        }
        selectedOptions.push(valItem)
      }
    }
    if (item.value > area.value && area.nextValue > -1) {
      item.code = undefined
      item.list = []
    }
  })
  const submitVal = {
    selectedOptions,
    value: area.code || '',
    tabIndex: index
  }
  emits('submit', submitVal)
  if (area.nextValue > -1) {
    const lists = area.list.find((item) => item.areaCode === area.code)
    if (lists?.childAreaList) areaList.value[area.nextValue].list = lists.childAreaList
  }
}

const setColMd = () => {
  return Math.floor(24 / props.areaNum)
}

const setColSpan = () => {
  let span = 12
  if (props.areaNum === 1) {
    span = 24
  }
  return span
}

function initAreaList() {
  areaList.value = []
  areaList.value = defaultList.slice(0, props.areaNum)
  areaList.value[areaList.value.length - 1].nextValue = -1
  areaList.value[0].list = props.areaTree
}

function dealDefaultValue() {
  const selectNum = props.areaNum
  const areaCodeVal = props.areaCode
  const province = getProvince(Number(areaCodeVal))
  const city = getCity(Number(areaCodeVal))
  const district = getDistrict(Number(areaCodeVal))
  const street = getStreet(Number(areaCodeVal))
  let cityList = [] as AreaTreeItem[] | undefined | null
  let districtList = [] as AreaTreeItem[] | undefined | null
  let streetList = [] as AreaTreeItem[] | undefined | null
  if (province && province !== -1 && selectNum >= 1) {
    areaList.value[0].code = province
    cityList = props.areaTree.find(
      (item: AreaTreeItem) => item.areaCode === province
    )?.childAreaList
  }
  if (city !== -1 && selectNum >= 2) {
    areaList.value[1].code = city
    districtList = cityList?.find((item: AreaTreeItem) => item.areaCode === city)?.childAreaList
  }
  if (district !== -1 && selectNum >= 3) {
    areaList.value[2].code = district
    streetList = districtList?.find(
      (item: AreaTreeItem) => item.areaCode === district
    )?.childAreaList
  }
  if (street !== -1 && selectNum === 4) {
    areaList.value[3].code = street
  }
  if (cityList && cityList.length && selectNum >= 2) areaList.value[1].list = cityList
  if (districtList && districtList.length && selectNum >= 3) areaList.value[2].list = districtList
  if (streetList && streetList.length && selectNum === 4) areaList.value[3].list = streetList
}

onMounted(() => {
  initAreaList()
})

watch(
  () => props.areaTree,
  (val) => {
    // 确定有几层，渲染对应的选择框
    initAreaList()
    dealDefaultValue()
  }
)
watch(
  () => props.areaCode,
  (newVal, oldVal) => {
    if (oldVal !== newVal && newVal && flag) {
      dealDefaultValue()
      flag = false
    }
    if (!newVal) {
      areaList.value.forEach((item: AreaItem) => {
        if (item.value !== 0) {
          item.list = []
        }
        item.code = undefined
      })
    }
  }
)
</script>
